import React from 'react';
import { t } from '@lingui/macro';
import { Modal, Group, Image } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { ModalProps } from '../Modal.types';

interface KeyboardCheatSheetModalContentProps {
    handleClose: () => void;
}

export const KeyboardCheatSheetModalContent: React.FC<
    KeyboardCheatSheetModalContentProps
> = ({ handleClose }) => (
    <Modal.Content>
        <Modal.Header>
            <Modal.Title>
                <Trans>Keyboard Shortcuts</Trans>
            </Modal.Title>
        </Modal.Header>
        <Modal.Section>
            <Group direction="vertical" gap="xl" mt="sm">
                <Group.Item>
                    <Group>
                        <Group.Item>
                            <Image
                                loading="lazy"
                                src={`${
                                    import.meta.env.BASE_URL
                                }assets/keyboardCheatSheet/space.svg`}
                                alt={t`Space keyboard shortcuts`}
                            />
                        </Group.Item>
                        <Group.Item>
                            <Trans>Play/Pause</Trans>
                        </Group.Item>
                    </Group>
                </Group.Item>
                <Group.Item>
                    <Group>
                        <Group.Item>
                            <Group gap="2xs" minWidth="54px">
                                <Group.Item>
                                    <Image
                                        loading="lazy"
                                        src={`${
                                            import.meta.env.BASE_URL
                                        }assets/keyboardCheatSheet/arrow-down.svg`}
                                        alt={t`Arrow down keyboard shortcuts`}
                                    />
                                </Group.Item>
                                <Group.Item>
                                    <Image
                                        loading="lazy"
                                        src={`${
                                            import.meta.env.BASE_URL
                                        }assets/keyboardCheatSheet/arrow-up.svg`}
                                        alt={t`Arrow up keyboard shortcuts`}
                                    />
                                </Group.Item>
                            </Group>
                        </Group.Item>
                        <Group.Item>
                            <Trans>Sample Select</Trans>
                        </Group.Item>
                    </Group>
                </Group.Item>
                <Group.Item>
                    <Group>
                        <Group.Item>
                            <Group gap="2xs" minWidth="54px">
                                <Group.Item>
                                    <Image
                                        loading="lazy"
                                        src={`${
                                            import.meta.env.BASE_URL
                                        }assets/keyboardCheatSheet/arrow-left.svg`}
                                        alt={t`Arrow left keyboard shortcuts`}
                                    />
                                </Group.Item>
                                <Group.Item>
                                    <Image
                                        loading="lazy"
                                        src={`${
                                            import.meta.env.BASE_URL
                                        }assets/keyboardCheatSheet/arrow-right.svg`}
                                        alt={t`Arrow right keyboard shortcuts`}
                                    />
                                </Group.Item>
                            </Group>
                        </Group.Item>
                        <Group.Item>
                            <Trans>Rewind/Fast-forward</Trans>
                        </Group.Item>
                    </Group>
                </Group.Item>
                <Group.Item>
                    <Group>
                        <Group.Item>
                            <Image
                                loading="lazy"
                                src={`${
                                    import.meta.env.BASE_URL
                                }assets/keyboardCheatSheet/return.svg`}
                                alt={t`Return keyboard shortcuts`}
                            />
                        </Group.Item>
                        <Group.Item>
                            <Trans>Restart Track</Trans>
                        </Group.Item>
                    </Group>
                </Group.Item>
            </Group>
        </Modal.Section>
    </Modal.Content>
);

export const KeyboardCheatSheet: React.FC<ModalProps> = ({
    handleClose,
    isOpen,
}) => {
    const handleCloseKeyboardCheatSheet = () => {
        handleClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleCloseKeyboardCheatSheet}>
            <KeyboardCheatSheetModalContent handleClose={handleClose} />
        </Modal>
    );
};

export default KeyboardCheatSheet;
